import Joi from '@hapi/joi'

export const OperationCardSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    operationEntityId: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Select Operatin Entity`,
        "any.required": `Operatin Entity required`
    }),
    collectionPointId: Joi.number().invalid().allow("", null).label("Collectionpoint")
   
   
}